import {AliffBoard} from "@buildwithflux/models";
import {Logger} from "@buildwithflux/shared";

import type {AutoLayoutBoardFetcher} from "./AutoLayoutBoardFetcher";
import type {AutoLayoutEventBus} from "./AutoLayoutEventBus";
import {DeepPcbAutoLayoutBaseService} from "./DeepPcbAutoLayoutBaseService";
import type {DeepPcbAutoLayoutEventMap} from "./DeepPcbAutoLayoutEventBus";

export class DeepPcbAutoLayoutBoardFetcher extends DeepPcbAutoLayoutBaseService implements AutoLayoutBoardFetcher {
    constructor(eventBus: AutoLayoutEventBus<DeepPcbAutoLayoutEventMap>, logger: Logger) {
        super("AutoLayoutBoardFetcher", eventBus, logger);
    }

    public async fetchBoard(boardLocation: string, abortSignal?: AbortSignal): Promise<AliffBoard> {
        this.logger.info(`Fetching board from ${boardLocation}`);
        return fetch(boardLocation, {signal: abortSignal})
            .then((response) => {
                return response.json();
            })
            .then((board) => board as AliffBoard);
    }
}
